import NewConstructionLayout from '../../../components/NewConstructionLayout';
import TermPageContent from '../../../components/TermPageContent/TermPageContent';
import { buildPrimaryTermPage } from '../../../util/buildPrimaryTermPage';

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryTermPage({
        basePath: '/new-construction-advertising/category',
        site: 'CONSTRUCTION',
        taxonomy: 'CATEGORY',
        LayoutComponent: NewConstructionLayout,
        ContentComponent: TermPageContent,
        additionalLayoutProps: {
            isBlog: true,
        },
        menuPropName: 'submenu',
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
